export default {
  home: {
    meta: {
      title: "AllChinaBuy Spreadsheet 2026: Funde, Guides & Ressourcen",
      description:
        "Entdecke das neueste AllChinaBuy Spreadsheet, Produktfunde, Kaufguides, Versandtipps, QC-Informationen und verwandte Ressourcen in einem organisierten Hub.",
      keywords:
        "AllChinaBuy spreadsheet, AllChinaBuy Funde, AllChinaBuy Guide, AllChinaBuy Bewertung",
    },
    hero: {
      badge: "Aktualisiert für 2026 · Mehrsprachig · Für Käufer gemacht",
      title: "AllChinaBuy Spreadsheet",
      titleAccent: "— Bessere Funde & Guides entdecken",
      subtitle:
        "Auf der Suche nach dem neuesten AllChinaBuy Spreadsheet? Entdecke organisierte Produktfunde, Kaufguides, QC-Informationen, Versandtipps und verwandte Ressourcen — alles in einem einfachen, durchsuchbaren Hub.",
      ctaPrimary: "AllChinaBuy Spreadsheet entdecken",
      ctaSecondary: "Jetzt kaufen",
      trust: "Unabhängige Ressource · Regelmäßig aktualisiert · Mehrsprachig",
      mockup: {
        label: "Spreadsheet-Vorschau",
        header: "Kategorie",
        headerProduct: "Produkt",
        headerResource: "Ressource",
        headerQc: "QC",
        headerUpdated: "Aktual.",
        row1: "Schuhe",
        row1Product: "Sneaker",
        row1Qc: "Ja",
        row2: "Hoodies",
        row2Product: "Sweatshirt",
        row2Qc: "Ja",
        row3: "Taschen",
        row3Product: "Tote",
        row3Qc: "Ja",
        row4: "Accessoires",
        row4Product: "Uhr",
        row4Qc: "Bewert.",
      },
    },
    categories: {
      title: "Nach Kategorie stöbern",
      subtitle:
        "Wähle eine Kategorie aus dem Dropdown oder den Karten unten, um direkt zur passenden Auswahl auf der Hauptwebsite zu springen.",
      dropdownLabel: "Kategorie wählen",
      dropdownPlaceholder: "Wähle eine Kategorie, um fortzufahren",
      dropdownCta: "Zur Kategorie",
      gridTitle: "Beliebte Produktkategorien",
      gridSubtitle: "Tippe auf eine Kategorie, um kuratierte Funde auf der Hauptseite zu entdecken.",
      allExternal: "Alle Kategorien öffnen in einem neuen Tab.",
    },
    about: {
      title: "Alles, was du brauchst, um AllChinaBuy zu entdecken",
      subtitle:
        "Finde die Informationen, die du vor dem Stöbern, Vergleichen oder Kaufen brauchst — organisiert, damit du schneller vorankommst.",
      p1: "Ein AllChinaBuy Spreadsheet ist eine einfache, organisierte Möglichkeit, Produktfunde, Verkäufernotizen, QC-Ergebnisse und Versanddetails an einem Ort zu verfolgen. Statt endlos durch Suchergebnisse zu scrollen, nutzen Käufer ein Spreadsheet, um Links zu sammeln, Optionen zu vergleichen und ihre nächste Bestellung mit klarem Überblick zu planen.",
      p2: "Dieses Hub bündelt die nützlichsten Ressourcen rund um das AllChinaBuy Spreadsheet — von Kategorie-Shortcuts und Kaufguides bis hin zu Versand- und QC-Informationen — damit du weniger Zeit mit Suchen und mehr Zeit mit dem Finden der Dinge verbringst, die du wirklich willst.",
      points: {
        organized: {
          title: "Organisierte Funde",
          desc: "Sammle Produkte und Links in einer klaren, durchsuchbaren Ansicht.",
        },
        compare: {
          title: "Einfacher Vergleich",
          desc: "Vergleiche Artikel nebeneinander, bevor du kaufst.",
        },
        updated: {
          title: "Immer aktuell",
          desc: "Folge Guides und Ressourcen, die regelmäßig aktualisiert werden.",
        },
      },
    },
    guides: {
      title: "Das Ressourcen-Center entdecken",
      subtitle: "Guides, die dir helfen, mit AllChinaBuy smarter einzukaufen.",
      cards: {
        spreadsheet: {
          title: "AllChinaBuy Spreadsheet",
          desc: "Entdecke organisierte Spreadsheet-Ressourcen und Produktkategorien.",
        },
        finds: {
          title: "Beliebte Funde",
          desc: "Entdecke beliebte Produktkategorien und nützliche Ressourcen.",
        },
        shipping: {
          title: "Versand-Guide",
          desc: "Verstehe Versandmethoden, Kosten und wichtige Überlegungen.",
        },
        qc: {
          title: "QC-Guide",
          desc: "Lerne, die Produktqualität vor dem Kauf zu prüfen.",
        },
        review: {
          title: "AllChinaBuy Bewertung",
          desc: "Funktionen, Vorteile, Grenzen und Wichtiges im Überblick.",
        },
        safety: {
          title: "Sicherheitscenter",
          desc: "Verkäuferchecks, Zahlungssicherheit, Produktrisiken und Versand.",
        },
      },
      cta: "Das Ressourcen-Center entdecken",
    },
    article: {
      title: "Neueste Guides",
      subtitle: "Frische, originale Artikel, die dir helfen, smarter einzukaufen.",
      cardTitle: "AllChinaBuy Spreadsheet: Der komplette Guide",
      cardDesc:
        "Erfahre, was ein AllChinaBuy Spreadsheet ist, wie du es nutzt, welche Kategorien du entdecken solltest und die Tipps, die dir helfen, bessere Produkte schneller zu finden.",
      tag: "Kompletter Guide",
      readMore: "Den vollständigen Guide lesen",
      updated: "Zuletzt aktualisiert",
    },
    faq: {
      title: "Häufig gestellte Fragen",
      subtitle: "Schnelle Antworten auf die häufigsten Fragen zum AllChinaBuy Spreadsheet.",
      q1: "Was ist ein AllChinaBuy Spreadsheet?",
      a1: "Es ist eine organisierte Ressource, die Produktfunde, Kategorien, Verkäufernotizen und QC-Details auflistet, damit Käufer an einem Ort stöbern und vergleichen können.",
      q2: "Wie nutze ich ein AllChinaBuy Spreadsheet?",
      a2: "Wähle eine Kategorie, stöbere durch die verlinkten Funde und vergleiche, bevor du die Hauptwebsite öffnest, um deinen Kauf abzuschließen.",
      q3: "Ist AllChinaBuy seriös?",
      a3: "AllChinaBuy ist eine Kaufplattform, aber du solltest Produkte, Verkäufer, Zahlungsmethoden und Versandoptionen immer selbst bewerten, bevor du entscheidest.",
      q4: "Ist AllChinaBuy sicher?",
      a4: "Sicherheit hängt von deiner Nutzung ab. Prüfe Verkäuferinformationen, QC-Fotos und Zahlungsoptionen sorgfältig, bevor du bestellst.",
      q5: "Wie viel kostet der AllChinaBuy-Versand?",
      a5: "Versandkosten variieren je nach Ziel, Gewicht und Methode. Prüfe die aktuellen Preise direkt auf der Hauptwebsite für eine genaue Schätzung.",
      q6: "Hat AllChinaBuy Gutscheine?",
      a6: "Aktionen und Rabatte ändern sich. Besuche die Hauptwebsite, um die aktuell verfügbaren Angebote zu sehen.",
      q7: "Was ist das AllChinaBuy-Lager?",
      a7: "Das Lager ist der Ort, an dem gekaufte Artikel empfangen, gelagert, für QC fotografiert und für den internationalen Versand vorbereitet werden.",
      q8: "Wie funktioniert AllChinaBuy QC?",
      a8: "Mit QC kannst du vor dem Versand Inspektionsfotos deiner Artikel anfordern, um die Qualität zu bestätigen und Probleme früh zu erkennen.",
    },
    finalCta: {
      title: "Bereit, AllChinaBuy-Ressourcen zu entdecken?",
      subtitle:
        "Starte mit dem AllChinaBuy Spreadsheet und entdecke die Guides, Funde und Ressourcen, die am wichtigsten sind.",
      primary: "AllChinaBuy Spreadsheet entdecken",
      secondary: "Hauptwebsite besuchen",
    },
  },
};